export default __webpack_public_path__ + "static/media/sign-icon.9095eb6c.svg";